export enum StatusEnum {
	Active = 'Active',
	Closed = 'Closed',
	Locked = 'Locked',
	Suspended = 'Suspended',
}

export default StatusEnum;
